<div class="div-box-margin, min-width-r" fxLayout="column" fxLayoutAlign="center center">
  <div class="word-break"> {{RearDecor}}{{RealValue ? RealValue : 'N/A'}}{{FrontDecor}} </div>
  <div class="aro-label">{{Title}}</div>
  <div class="aro-label">{{Comment}}</div>
</div>